import {
  DeveloperStatus,
  TAPICreateDeveloperRequest,
  TAPICreateDeveloperResponse,
} from './registration.types';

export const mockedCreatedDeveloperRequest: TAPICreateDeveloperRequest = {
  first_name: 'Sarhan',
  last_name: 'Azizov',
  email: 'sarhan.azizov@email.com',
  dial_country_id: '941058a3-ed78-486c-8b0b-5e3faa4a1a65',
  phone_number: '1234567',

  company_name: "sarhan's company",
  website: 'http://site.com',
  country: 'Ukraine',
  state: '',
  city: 'Dnipro',
  postal_code: '49000',
  address: 'sadasdsa',
};

export const mockedCreatedDeveloper: TAPICreateDeveloperResponse = {
  id: 'id',
  status: DeveloperStatus.REGISTERED,
  status_change_date: '2021-10-19 10:40:50.301991+00:00',
  created_at: '2021-10-19 10:40:50.301991+00:00',
  updated_at: null,

  ...mockedCreatedDeveloperRequest,
};
